export const extractTextContent = (input) => {
  if (input === undefined || input === null || input === '') return
  return input.replace(/<(mention|hashtag)[^>]*>(.*?)<\/\1>/g, '$2')
}

export const removeEscapeCharacters = (text) => {
  if (text === undefined || text === null || text === '') return ''
  return text.replace(/\\"/g, '"')
}
